/**
 *
 * Asynchronously loads the component for GuideLine
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GuideLineTB = lazyLoad(
  () => import('./index'),
  module => module.GuideLineTB,
);
